import React from "react";
import { Form, Row, Col, Select, InputNumber, DatePicker } from "antd";
import { PDFDownloadLink } from '@react-pdf/renderer';
import PDFDocument from './pdfExport';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';

function AnalyticsFilters(props) {
    const [form] = Form.useForm();
    
    const onFinish = (values) => {
        props.handleRunAnalysis(values);
    };

    return (
        <Form form={form} onFinish={onFinish}>
            <Row gutter={8}>
                <Col>
                    <Form.Item
                        name="cadence"
                        rules={[{ required: true, message: 'Please select a cadence!' }]}
                    >
                        <Select
                            style={{ width: 250 }}
                            dropdownMatchSelectWidth={false}
                            placeholder="Select Cadence"
                        >
                            {props.cadenceFilter.map((item) => (
                                <Select.Option key={item} value={item}>
                                    {item}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
                <Col>
                    <Form.Item
                        name="numberOfPeriods"
                        rules={[{ required: true, message: 'Please enter the number of periods!' }]}
                    >
                        <InputNumber
                            style={{ width: 250 }}
                            placeholder="Number of Periods"
                        />
                    </Form.Item>
                </Col>
                <Col>
                    <Form.Item
                        name="endDate"
                        rules={[{ required: true, message: 'Please select an end date!' }]}
                    >
                        <DatePicker
                            style={{ width: 250 }}
                            placeholder="Select End Date"
                        />
                    </Form.Item>

                </Col>
                <Col>
                    <Form.Item
                        name="includePeriodToDate"
                        rules={[{ required: true, message: 'Please select whether to include the period to date!' }]}
                    >
                        <Select
                            style={{ width: 250 }}
                            dropdownMatchSelectWidth={false}
                            placeholder="Include Period to Date"
                        >
                            {props.includePeriodToDateFilter.map((item) => (
                                <Select.Option key={item} value={item}>
                                    {item}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                </Col>
                <Col>
                    <Form.Item
                        name="accountGrouping"
                        rules={[{ required: true, message: 'Please select an account grouping!' }]}
                    >
                        <Select
                            dropdownMatchSelectWidth={false}
                            style={{ width: 250 }}
                            placeholder="Select Account Grouping"
                            onChange={(e) => {
                                props.setAccountGrouping(e);
                                props.setSelectGroup(null);
                                form.setFieldsValue({ selectGroup: undefined });
                            }}
                        >
                            {props.accountGroupingFilter.map((item) => (
                                <Select.Option key={item} value={item}>
                                    {item}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                </Col>
                <Col>
                    <Form.Item
                        name="selectGroup"
                        rules={[]}
                    >
                        <Select
                            style={{ width: 250 }}
                            placeholder="Select Group"
                            dropdownMatchSelectWidth={false}
                            onChange={(e) => props.setSelectGroup(e)}
                            disabled={props.selectGroupFilter.length === 0 || props.loadingGroupingOptions}
                            loading={props.loadingGroupingOptions}
                        >
                            {props.selectGroupFilter.map((item) => (
                                <Select.Option key={item.id} value={item.id}>
                                    {item.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                </Col>
                <Col>
                    <Form.Item>
                        <LoadingButton
                            htmlType="submit" loadingPosition="start"
                            loading={props.runAnalyticsButtonLoading} disableElevation fullWidth size="small" type="submit" variant="contained" color="primary"
                            sx={{ fontSize: 14, width: '150px', textTransform: 'none' }}
                        >
                            Run Analysis
                        </LoadingButton>
                    </Form.Item>

                </Col>
                <Col>
                    <Form.Item>
                        <PDFDownloadLink
                            style={{ display: "none" }}
                            document={
                                <PDFDocument
                                    data={props.exportData}
                                    canvasUrl={props.canvasUrl}
                                />
                            }
                            fileName={props.exportFileName}
                        >
                            <p ref={props.pdfDownloadLinkRef} style={{ display: "none" }}>Download buttton</p>
                        </PDFDownloadLink>
                        <Button
                            type="primary"
                            onClick={props.handleExportPDF}
                            disabled={props.exportPDFButtonLoading}
                            disableElevation fullWidth size="small" variant="outlined" color="secondary"
                            sx={{ fontSize: 14, width: '100%', textTransform: 'none' }}
                        >
                            Export PDF
                        </Button>
                    </Form.Item>

                </Col>
            </Row>
        </Form>
    );
}

export default AnalyticsFilters;
